// This file is auto-generated by scripts/increment-build.js
// Do not edit manually

export const BUILD_INFO = {
  "buildNumber": 436,
  "version": "1.0.0",
  "buildDate": "2025-08-28T21:38:06.680Z",
  "gitCommit": "7bfaf3b",
  "environment": "development",
  "gitBranch": "main"
} as const;

export default BUILD_INFO;
